import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "./list-snippet-item.module.css";
import cx from "classnames";
import { ArrowRight } from "../../../assets/arrow-right";
export const ListSnippetItem = ({ smallImage =false , isMobile =false , heading , snippet , linkText , href , image , alt , handleTrackEvent , customIcon  })=>{
    const handleLinkTrackingEvent = ()=>{
        handleTrackEvent();
    };
    return /*#__PURE__*/ _jsx("li", {
        className: cx({
            [styles.containerWithoutImage]: !image,
            [styles.container]: image,
            [styles.containerWithSmallImage]: smallImage
        }),
        children: !image ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: styles.heading,
                    children: heading
                }),
                /*#__PURE__*/ _jsxs("p", {
                    className: styles.snippet,
                    children: [
                        snippet,
                        " "
                    ]
                }),
                /*#__PURE__*/ _jsxs("a", {
                    href: href,
                    className: styles.link,
                    onClick: handleLinkTrackingEvent,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.linkText,
                            children: [
                                linkText,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.icon,
                            children: /*#__PURE__*/ _jsx(ArrowRight, {})
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                !isMobile ? /*#__PURE__*/ _jsx("div", {
                    className: cx({
                        [styles.imageContainerSmall]: smallImage,
                        [styles.imageContainer]: !smallImage
                    }),
                    children: /*#__PURE__*/ _jsx("a", {
                        href: href,
                        onClick: handleLinkTrackingEvent,
                        children: /*#__PURE__*/ _jsx("img", {
                            src: image,
                            alt: alt,
                            className: styles.image
                        })
                    })
                }) : null,
                linkText ? /*#__PURE__*/ _jsxs("div", {
                    className: styles.textContainer,
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: styles.heading,
                            children: heading
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            className: styles.snippet,
                            children: [
                                snippet,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("a", {
                            href: href,
                            ...customIcon && {
                                target: "_blank"
                            },
                            className: styles.link,
                            onClick: handleLinkTrackingEvent,
                            children: [
                                linkText,
                                " ",
                                /*#__PURE__*/ _jsx("div", {
                                    className: cx(styles.icon, {
                                        [styles.customIcon]: customIcon
                                    }),
                                    children: customIcon ? customIcon : /*#__PURE__*/ _jsx(ArrowRight, {})
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ _jsx("div", {
                    className: styles.textContainer,
                    children: /*#__PURE__*/ _jsx("a", {
                        href: href,
                        className: styles.linkHeading,
                        onClick: handleLinkTrackingEvent,
                        children: heading
                    })
                })
            ]
        })
    });
};
